import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, Typography, Box, TextField, Button, Link } from '@mui/material';
import {
  AlertSeverity,
  EmailRequest,
  setAlert,
  useAppDispatch,
  useAppSelector,
  useSendEmailMutation,
} from 'api';
import { ModalContainerStyled, ModalHeaderStyled } from 'app/common';
import React, { useState } from 'react';
type PowerBIReportRequestSupportModalProps = {
  open: boolean;
  handleCloseModal: () => void;
};
export const PowerBIReportRequestSupportModal: React.FC<PowerBIReportRequestSupportModalProps> =
  ({ open, handleCloseModal }) => {
    const dispatch = useAppDispatch();
    const { currentMenuItem } = useAppSelector(state => state.menuItem);
    const { mockUser } = useAppSelector(state => state.appUser);
    const [bodyValue, setBodyValue] = useState<string>('');
    const [postAction, { isLoading: isSending }] = useSendEmailMutation();

    const handleBodyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setBodyValue(event.target.value);
    };

    const handleSend = async () => {
      let responseState = { message: '', status: AlertSeverity.Success };
      try {
        const emailRequest: EmailRequest = {
          to: currentMenuItem?.supportEmail,
          body: bodyValue,
          subject: `OneAnalytics Help Request for ${currentMenuItem?.description} from ${mockUser?.userName}, ${mockUser?.displayName}, ${mockUser?.email}`,
          isHtml: true,
        };
        const response: any = await postAction(emailRequest);
        if (response.error) {
          responseState.message = 'Something went wrong.';
          responseState.status = AlertSeverity.Error;
        } else {
          responseState.message = 'Email sent.';
          responseState.status = AlertSeverity.Success;
        }
      } catch (e) {
        responseState.message = 'Something went wrong.';
        responseState.status = AlertSeverity.Error;
      }
      dispatch(
        setAlert({
          message: responseState.message,
          severity: responseState.status,
        })
      );

      if (responseState.status === AlertSeverity.Success) handleCloseModal();
    };

    return (
      <Modal open={open} onClose={handleCloseModal}>
        <ModalContainerStyled
          style={{
            borderTopLeftRadius: '0.5rem',
            borderTopRightRadius: '0.5rem',
          }}
        >
          <ModalHeaderStyled>
            <Typography variant="subtitle1">Request Support</Typography>
            <Link component="button" mr="10px" onClick={handleCloseModal}>
              <FontAwesomeIcon icon={faXmark} size="2x" color="#d8d3d3" />
            </Link>
          </ModalHeaderStyled>
          <Box
            flexDirection="column"
            gap="20px"
            p="1rem"
            display="block"
            overflow="auto"
          >
            <TextField
              sx={{ width: '100%' }}
              label="Request Support"
              multiline
              onChange={handleBodyChange}
              rows={7}
            />
          </Box>
          <Box
            display="flex"
            justifyContent="flex-end"
            padding="20px"
            gap="20px"
            sx={{ borderTop: '1px solid lightgray' }}
          >
            <Button variant="text" onClick={handleCloseModal}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSend}
              loading={isSending}
              loadingPosition="start"
              sx={{ width: '100px' }}
              fullWidth
            >
              <span style={{ paddingTop: '3px' }}>Submit</span>
            </Button>
          </Box>
        </ModalContainerStyled>
      </Modal>
    );
  };
